/* Deye Cart Category Guard
 * Prevents mixing deye-hvac-systems (Heat Pump) products with other categories
 * in the same cart. Heat Pump requires Bank Deposit which is incompatible
 * with other payment methods used for the rest of the catalog.
 */
(function () {
  if (window.DeyeCartGuard) return;

  var HP_IDS = new Set((window.DEYE_HEAT_PUMP_PRODUCT_IDS || []).map(Number));

  // Shopify's `| t` filter HTML-escapes characters like ' " & < > before
  // emitting them to the page, so the strings we receive from Liquid contain
  // entities like &#39;. Decode them once so textContent renders correctly.
  function decodeEntities(s) {
    if (typeof s !== 'string') return s;
    var ta = document.createElement('textarea');
    ta.innerHTML = s;
    return ta.value;
  }

  var I18N_RAW = window.DEYE_CART_GUARD_I18N || {
    modal_title: "Items can't be combined",
    body_blocks_other: 'Heat Pump products need to be ordered separately. Clear your current cart to add this item, or finish your existing checkout first.',
    body_blocks_hp: "This item can't be combined with Heat Pump products in your cart. Clear your current cart to add this item, or finish your existing checkout first.",
    clear_and_add: 'Clear cart and add',
    cancel: 'Cancel',
    banner_mixed: "Your cart contains Heat Pump and other products which can't be checked out together. Please remove one category to continue."
  };
  var I18N = {};
  Object.keys(I18N_RAW).forEach(function (k) { I18N[k] = decodeEntities(I18N_RAW[k]); });

  var STYLE_ID = 'deye-cart-guard-style';
  var MODAL_ID = 'deye-cart-guard-modal';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      '.deye-cg-overlay{position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;}',
      '.deye-cg-modal{background:#fff;border-radius:8px;max-width:480px;width:100%;padding:24px;box-shadow:0 8px 32px rgba(0,0,0,.2);font-family:inherit;}',
      '.deye-cg-modal h3{margin:0 0 12px;font-size:18px;font-weight:700;color:#111;}',
      '.deye-cg-modal p{margin:0 0 20px;font-size:14px;line-height:1.5;color:#333;}',
      '.deye-cg-actions{display:flex;gap:12px;justify-content:flex-end;flex-wrap:wrap;}',
      '.deye-cg-btn{padding:10px 18px;border-radius:4px;border:1px solid #111;font-size:14px;cursor:pointer;font-weight:500;line-height:1;}',
      '.deye-cg-btn-primary{background:#F7D400;color:#111;border-color:#F7D400;}',
      '.deye-cg-btn-secondary{background:#fff;color:#111;}',
      '.deye-cg-banner{background:#FFF4D6;border:1px solid #F7D400;color:#5A4A00;padding:12px 16px;border-radius:4px;margin:12px 0;font-size:14px;line-height:1.4;}'
    ].join('');
    document.head.appendChild(s);
  }

  function classify(productId) {
    return HP_IDS.has(Number(productId)) ? 'hp' : 'other';
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function classifyCart(cart) {
    var hasHp = false, hasOther = false;
    (cart.items || []).forEach(function (i) {
      if (HP_IDS.has(Number(i.product_id))) hasHp = true; else hasOther = true;
    });
    return { hasHp: hasHp, hasOther: hasOther, empty: !(cart.items || []).length };
  }

  function clearCart() {
    return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });
  }

  function closeModal() {
    var el = document.getElementById(MODAL_ID);
    if (el) el.remove();
  }

  function showModal(opts) {
    injectStyle();
    closeModal();
    return new Promise(function (resolve) {
      var overlay = document.createElement('div');
      overlay.id = MODAL_ID;
      overlay.className = 'deye-cg-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');

      var modal = document.createElement('div');
      modal.className = 'deye-cg-modal';

      var h = document.createElement('h3');
      h.textContent = I18N.modal_title;
      modal.appendChild(h);

      var p = document.createElement('p');
      p.textContent = opts.body;
      modal.appendChild(p);

      var actions = document.createElement('div');
      actions.className = 'deye-cg-actions';

      var cancelBtn = document.createElement('button');
      cancelBtn.type = 'button';
      cancelBtn.className = 'deye-cg-btn deye-cg-btn-secondary';
      cancelBtn.textContent = I18N.cancel;
      cancelBtn.addEventListener('click', function () { closeModal(); resolve(false); });
      actions.appendChild(cancelBtn);

      if (opts.allowClear) {
        var okBtn = document.createElement('button');
        okBtn.type = 'button';
        okBtn.className = 'deye-cg-btn deye-cg-btn-primary';
        okBtn.textContent = I18N.clear_and_add;
        okBtn.addEventListener('click', function () { closeModal(); resolve(true); });
        actions.appendChild(okBtn);
      }

      modal.appendChild(actions);
      overlay.appendChild(modal);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) { closeModal(); resolve(false); }
      });
      document.body.appendChild(overlay);
    });
  }

  function canAdd(productId) {
    if (!productId) return Promise.resolve(true);
    if (HP_IDS.size === 0) return Promise.resolve(true);
    var incoming = classify(productId);
    return getCart().then(function (cart) {
      var c = classifyCart(cart);
      if (c.empty) return true;
      var willMix = (incoming === 'hp' && c.hasOther) || (incoming === 'other' && c.hasHp);
      if (!willMix) return true;
      var body = incoming === 'hp' ? I18N.body_blocks_other : I18N.body_blocks_hp;
      return showModal({ body: body, allowClear: true }).then(function (proceed) {
        if (!proceed) return false;
        return clearCart().then(function () { return true; });
      });
    }).catch(function () { return true; });
  }

  function renderCartWarning() {
    injectStyle();
    var slots = document.querySelectorAll('[data-cart-warning-slot]');
    if (!slots.length) return;
    getCart().then(function (cart) {
      var c = classifyCart(cart);
      var mixed = c.hasHp && c.hasOther;
      slots.forEach(function (slot) {
        slot.innerHTML = '';
        if (mixed) {
          var div = document.createElement('div');
          div.className = 'deye-cg-banner';
          div.setAttribute('role', 'alert');
          div.textContent = I18N.banner_mixed;
          slot.appendChild(div);
        }
      });
    });
  }

  window.DeyeCartGuard = {
    canAdd: canAdd,
    renderCartWarning: renderCartWarning,
    isHeatPump: function (productId) { return HP_IDS.has(Number(productId)); }
  };

  document.addEventListener('DOMContentLoaded', renderCartWarning);
  document.addEventListener('cart:change', renderCartWarning);
  document.addEventListener('cart:refresh', renderCartWarning);
})();

/* AU storefront header fallback
 * The AU homepage can be served from an older Shopify index page cache. This
 * keeps the Accessories panel complete even when that stale HTML references
 * older theme assets.
 */
(function () {
  if (window.DeyeAuHeaderMenuFallback) return;
  window.DeyeAuHeaderMenuFallback = true;

  function isAustraliaStorefront() {
    return (
      window.location.pathname.indexOf('/en-au') === 0 ||
      (window.Shopify && window.Shopify.country === 'AU') ||
      window.location.hostname.indexOf('shopifypreview.com') !== -1
    );
  }

  var products = [
    ['deye-data-logger-series-wifi-4g-ethernet-monitoring-accessories', 'Deye Data Logger Series | WiFi / 4G / Ethernet Monitoring Accessories', 'https://cdn.shopify.com/s/files/1/0976/1040/0053/files/www.deyeinverter.com_deyeinverter_2025_08_12_stick-logger.png?v=1780299762', 'Deye Data Logger Series WiFi and Ethernet monitoring accessories'],
    ['deye-single-phase-meter-ddsu666', 'CHINT Single-phase Meter DDSU666', 'https://cdn.shopify.com/s/files/1/0976/1040/0053/files/DDSU666.png?v=1778050108', 'Deye DDSU666 - single-phase smart energy meter for solar PV monitoring'],
    ['deye-ai-w5-1-b-pdu1-base', 'Deye AI-W5.1-B-PDU1 + Base | Low-Voltage Stackable Battery Control & Mounting Set', 'https://cdn.shopify.com/s/files/1/0976/1040/0053/files/new1.jpg?v=1780024333', 'Deye AI-W5.1-B-PDU1 + Base low-voltage stackable battery control and mounting set'],
    ['deye-dc-combiner-box-300', 'Deye DC Combiner Box 300 | High-Voltage Battery Combiner Box', 'https://cdn.shopify.com/s/files/1/0976/1040/0053/files/17984-Combiner_Box_1920x1920_c56b6c0e-29ff-4036-8636-abc8cccb3b5b.png?v=1776243412', 'Deye DC Combiner Box 300 high-voltage battery combiner box']
  ];

  function handleFromHref(href) {
    var match = String(href || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function buildCard(product) {
    var handle = product[0];
    var title = product[1];
    var image = product[2];
    var alt = product[3];
    var item = document.createElement('li');
    item.className = 'header__submenu-products-item';
    item.innerHTML =
      '<a href="/en-au/collections/accessories/products/' + handle + '" class="header__submenu-products-link" aria-label="' + escapeHtml(title) + '">' +
        '<div class="header__submenu-products-media">' +
          '<img src="' + image + '&width=240" srcset="' + image + '&width=120 120w, ' + image + '&width=180 180w, ' + image + '&width=240 240w" width="240" height="240" loading="lazy" class="header__submenu-products-image" alt="' + escapeHtml(alt) + '">' +
        '</div>' +
        '<div class="header__submenu-products-content">' +
          '<span class="header__submenu-products-title">' + escapeHtml(title) + '</span>' +
        '</div>' +
      '</a>';
    return item;
  }

  function hydrate() {
    if (!isAustraliaStorefront()) return;
    var blocks = document.querySelectorAll('.header__submenu-products');
    blocks.forEach(function (block) {
      var heading = block.querySelector('.header__submenu-products-heading');
      if (!heading || heading.textContent.trim() !== 'Accessories') return;
      var list = block.querySelector('.header__submenu-products-list');
      if (!list) return;

      list.querySelectorAll('a[href*="/products/logger-dl1000b-wifi"]').forEach(function (link) {
        var item = link.closest('.header__submenu-products-item, li');
        (item || link).remove();
      });

      list
        .querySelectorAll('a[href*="/products/deye-data-logger-series-wifi-4g-ethernet-monitoring-accessories"]')
        .forEach(function (link, index) {
          var item = link.closest('.header__submenu-products-item, li');
          if (index > 0) {
            if (item) item.remove();
          } else if (item && item !== list.firstElementChild) {
            list.insertBefore(item, list.firstElementChild);
          }
        });

      var existing = new Set(Array.prototype.map.call(
        list.querySelectorAll('a[href*="/products/"]'),
        function (link) { return handleFromHref(link.getAttribute('href')); }
      ));

      products.forEach(function (product) {
        if (!existing.has(product[0])) list.appendChild(buildCard(product));
      });

      list.classList.remove('header__submenu-products-list--count-1', 'header__submenu-products-list--count-2', 'header__submenu-products-list--count-3');
      list.classList.add('header__submenu-products-list--count-4');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
  document.addEventListener('shopify:section:load', hydrate);
})();

